import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Input, Button, Checkbox, Modal, DatePicker,Tooltip,Divider ,Icon} from "antd";
import {
  numberFormat,
  phoneNumFormat,
  formatDate,
} from "../../util";
import {
  SearchOutlined,LockOutlined
} from '@ant-design/icons';
import string from "../../string";
import { httpGet, httpUrl, httpPost, httpDownload } from "../../api/httpClient";
import SelectBox from "../../components/common/SelectBox";
import SelectBox2 from "../../components/common/SelectBox2";


const Search = Input.Search;
const RangePicker = DatePicker.RangePicker;

class PlayerBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
     searchText:"",
     pagination:  {
        total: 0,
        current:0,
     },
     list: [],
    };
  }

  getPlayerBoardlist = (params = {}) => {
    let pageNum = params.pageNum || 1;
    const { searchText } = this.state
    httpGet(httpUrl.playerBoardList, [10, pageNum, searchText])
    .then(res => {
      const pagination = {...this.state.pagination}
      pagination.total = res.data.totalCount;
      this.setState({
        list: res.data.list,
        pagination,
      })
    })
  }  

  
 componentDidMount() {
 this.getPlayerBoardlist();
}

onSearch = (value) => {
  this.setState(
    {
      searchText: value,
    },
    () => {
      this.getPlayerBoardlist({});

    }
  );
};

onUpdateStatus = (params) => {
  let self = this;
  let updateData = {
      idx : params.idx,
      status: params.status,   
      paidDate: params.paidDate,
  };  
  Modal.confirm({
    title: "입금처리",
    content: "해당 구좌를 지급완료 처리합니다.",
    okText: "확인",
    cancelText: " 취소",
    onOk() {
      httpPost(httpUrl.playerBoardUpdate, [], updateData)
        .then((res) => {          
          if (res.data === true) {
            Modal.info({
              title: "지급완료",
              content: "지급완료 처리 되었습니다."
            })          
            self.getPlayerBoardlist();          
          } else {
            Modal.error({
              title: "오류",
              content: "오류가 발생했습니다. 관리자에게 문의해주세요."
            });
          }
        })
    }
  })
};
  

handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager
    });
    this.getPlayerBoardlist({
      pageNum: pager.current,
    });
  };


  render() {
    const accountColumns = [      
      {
        title: "",
        dataIndex: "idx",
        key: "idx",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },       
      {
        title: "아이디",
        dataIndex: "userId",
        key: "userId",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data} {row.userLoan === 1 ? <span style={{fontWeight:'bold'}}>(여신)</span> : ""}
           </div>
        ),
      },    
      {
        title: "이름",
        dataIndex: "userName",
        key: "userName",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },  
      {
        title: "은행",
        dataIndex: "userBankCode",
        key: "userBankCode",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {string.bankString[data ]}
           </div>
        ),
      },  
      {
        title: "계좌번호",
        dataIndex: "userBankAccount",
        key: "userBankAccount",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
        {data}
           </div>
        ),
      },  
      {
        title: "예금주",
        dataIndex: "userAccountHolder",
        key: "userAccountHolder",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },  
      {
        title: "구좌번호",
        dataIndex: "accountSeq",
        key: "accountSeq",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },    
      {
        title: "반복",
        dataIndex: "repeat",
        key: "repeat",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => (
          <div style={{fontSize:12.5}}>
         {data}        
          </div>
        )
      },     
      {
        title: "상태",
        dataIndex: "status",
        key: "status",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data === 1 ? "참여" : data === 2 ? <span style={{color: 'red'}}>졸업(미지급)</span> : data === 3 ? <span style={{fontWeight:'bold',color:'blue'}}>졸업(지급완료)</span> : ""}
           </div>
        ),
      },    

      {
        title: "참여일",
        dataIndex: "createDate",
        key: "createDate",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
         <div style={{fontSize:12.5}}>
        {formatDate(data)}
         </div>
          ),
      },       
      {
        title: "졸업일",
        dataIndex: "exitDate",
        key: "exitDate",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
         <div style={{fontSize:12.5}}>
        {data === null ? "-" : formatDate(data)}
         </div>
          ),
      },       
      {
        title: "지급일",
        dataIndex: "paidDate",
        key: "paidDate",
     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
         <div style={{fontSize:12.5}}>
        {data === null ? "-" :  formatDate(data)}
         </div>
          ),
      },       
      {
        title: "",
        dataIndex: "",
        key: "",     
        className: "support-column-number fs-15 lh-21",
        render: (row) => {         
        if (row.status === 3 || row.status === 1 || row.repeat === 'D' || row.repeat === 'E') return (" ");
      
        else return (<div>
            <Button 
         onClick={() => {
          this.onUpdateStatus({
            idx: row.idx,
            status: row.status
          })}}
           >지급</Button>

        </div>)
         
       
        },
      },       
    ];

    // const expandedRowRender = (record) => {
    //   let dataArr = [record];
    //   const dropColumns = [
       
    //     {
    //       title: "LOCK",
    //       dataIndex: "lock",
    //       key: "lock",
    //       // width: 80,
    //       className: "support-column-number fs-15 lh-21",
    //       render: (data, row, index) => (
    //         <div key={`lock${index}`}>
    //           <Button
    //           style={{fontSize:12.5}}
    //             onClick={() => {
    //               this.setState(
    //                 {
    //                   selectedSerial: row,
    //                 },
    //                 () => {
    //                   this.showCoinLockList();
    //                 }
    //               );
    //             }}>
    //            <LockOutlined />LOCK
    //           </Button>
    //         </div>
    //       ),
    //     },
    //     {
    //       title: "상태",
    //       dataIndex: "deleted",
    //       className: "support-column-number fs-15 lh-21",
    //       render:
    //         // data => <div>{data === 0 ? '삭제' : '-'}</div>
    //         (data, row) => (
    //           <div>
    //             <SelectBox2
                
    //               value={string.deleteString[data]}
    //               code={string.toggleCode}
    //               codeString={string.deleteString}
    //               onChange={(value) => {
    //                 if (parseInt(value) !== row.deleted) {
    //                   this.onDelete(row);
    //                 }
    //               }}
    //             />
    //           </div>
    //         ),
    //     },
        
       
    //   ];
    //   return (
    //     <Table
    //       rowKey={(record) => record.idx}
    //       columns={dropColumns}
    //       dataSource={dataArr}
    //       pagination={false}
    //     />
    //   );
    // };


    return (
      <div className="flex-row flex-column">
       
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
          }}>
          <Divider orientation="left" style={{fontSize:21.5}}>현황판</Divider>
          
        </div>
       
       

<div className="flex-row flex-center flex-end m-b-10">
  
           </div>
        <div className="flex-row flex-center m-b-10 flex-sb">
          <div className="flex-row flex-center">            
          </div>          
          <div className="flex-row flex-center">
            <label htmlFor="searchType">&nbsp;</label>     
            <Search
              placeholder={`아이디로 검색하세요.`}
              enterButton={<SearchOutlined/>}
              allowClear
              onSearch={this.onSearch}
              style={{ width: 400 }}
            />
          </div>
        </div>
        <Table
          id="account-table"
          className="flex-1"
          rowKey={(record) => record.idx}
          columns={accountColumns}
          dataSource={this.state.list}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        //   expandedRowRender={expandedRowRender}
          
        
        />
       
      </div>
    );
  }
}


export default PlayerBoard;
